import { Icon } from '@rsuite/icons';
import { useState, useEffect } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Button, Stack } from 'rsuite';

const BOTTOM_DOCKER_CLASS = [
  'tg-bottom-docker',
  'max-md:!h-auto max-md:!overflow-visible',
  'max-md:px-3 max-md:pt-3',
  'max-md:pb-[calc(0.75rem+env(safe-area-inset-bottom))]',
  'max-md:[&_.rs-btn]:!px-3',
].join(' ');
const BOTTOM_DOCKER_STACK_CLASS = [
  'max-md:!w-full max-md:!justify-between max-md:!gap-2',
  'max-md:[&>.rs-stack-item]:min-w-0',
].join(' ');

type Prop = {
  onCancelClicked: () => void;
  onContinueClicked: () => void;
  cancelLabel: string;
  mobileCancelLabel: string;
  continueLabel: string;
  threshold: number | 0;
};

export default function BottomDocker({
  onCancelClicked,
  onContinueClicked,
  cancelLabel,
  mobileCancelLabel,
  continueLabel,
  threshold = 250,
}: Prop): JSX.Element | null {
  const [showDocker, setShowDocker] = useState(false);

  useEffect(() => {
    const handleScroll = (): any => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;

      if (scrollTop + windowHeight >= documentHeight - threshold) {
        setShowDocker(true);
      } else {
        setShowDocker(false);
      }
    };

    handleScroll(); // run on mount in case initial position qualifies
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return (
    <div className={`${BOTTOM_DOCKER_CLASS} ${showDocker ? '' : 'md:!hidden'}`}>
      <Stack
        spacing={16}
        justifyContent="flex-end"
        direction="row"
        className={BOTTOM_DOCKER_STACK_CLASS}
      >
        <Stack.Item>
          <Button appearance="subtle" onClick={onCancelClicked}>
            {mobileCancelLabel ? (
              <>
                <span className="hidden !text-[1em] md:inline">
                  {cancelLabel}
                </span>
                <span className="md:hidden">{mobileCancelLabel}</span>
              </>
            ) : (
              cancelLabel
            )}
          </Button>
        </Stack.Item>
        <Stack.Item>
          <Button
            className="next-btn"
            appearance="primary"
            onClick={onContinueClicked}
          >
            {continueLabel}
            <Icon as={FaArrowRight} />
          </Button>
        </Stack.Item>
      </Stack>
    </div>
  );
}
